/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { StyleSheet, View, TouchableOpacity } from 'react-native';
import { FontAwesome5 } from '@expo/vector-icons';
import { isWeb } from '@global/screens';
import { hasNoAccess, hasAccessEditTargetSetting } from '@global/helpers';
import Colors from '@global/colors';
import SelectBox from '@components/form/SelectBox';
import SociollaText from '@components/sociolla/SociollaText';
import Table from '@components/table/Table';
import * as Layout from '@components/screen/Layout';

import useApi from '@/hooks/useApi';
import { MsB2b } from '@api/ms-b2b';
// import { paramsReseted } from '@/store/params';
import { showAlert } from '@/store/global';
import { FILTER_YEARS } from '@/constants';
import {
  TABLE_STRUCTURES,
  SALES_VALUE_LIST,
  PRODUCT_FOCUS_LIST,
  DOORS_LIST,
  TABS,
  IGNORE_TARGET_ID,
} from '@/constants/target-settings';

const subStyle = { paddingLeft: 10 };
const today = new Date();
let target_init = true;

const TargetSettingScreen = (props) => {
  const dispatch = useDispatch();
  const [tableData, setTableData] = useState([]);
  const [activeTab, setActiveTab] = useState('sales-value');
  const [loading, setLoading] = useState(false);
  const [filterYear, setFilterYear] = useState(today.getFullYear());

  const getTargetSetting = useApi(MsB2b.getTargetSetting);

  const hasAccess = hasNoAccess([
    'salesman',
    'sales_supervisor',
    'finance_supervisor',
    'marketing_support',
  ]);

  const handleTargetSettingValues = ({
    national = {},
    channel = {},
    branch = {},
    salesman = {},
  }) => {
    let final_result = [];
    // Check GT or MT code
    const channelCode = (data) => {
      let result = data?.target_id?.toLowerCase();
      try {
        if (
          result.indexOf(activeTab == 'sales-value' ? 'branch' : 'salesman') >
          -1
        ) {
          result = result.split('-')[1];
        }
      } catch (err) {}
      return result;
    };

    const resetValue = (data) => {
      data.status = '';
      data.created_by = '';
      data.last_updated = '';
      return data;
    };

    // Initial Value
    if (activeTab == 'sales-value') {
      const SALESTEAMS = (salesman?.data || []).map((item) => {
        return {
          target_type: 'salesman',
          target_id: item.id,
          target_name: item.name,
          title: `Sales Value - Sales Team`,
          title_section: `${item.name} | ${filterYear}`,
          status: item?.current_status ? item.current_status : '',
          created_by: item?.created_by?.name ? item.created_by.name : '',
          last_updated: item?.updated_by?.name || '',
          textStyle: subStyle,
        };
      });

      final_result = [...SALES_VALUE_LIST, ...SALESTEAMS];
    } else if (activeTab == 'doors') {
      final_result = DOORS_LIST;
    } else if (activeTab == 'product-focus') {
      final_result = PRODUCT_FOCUS_LIST;
    }

    // Check GT or MT value / Branch value (DOORS)
    if (['sales-value', 'product-focus'].includes(activeTab)) {
      const code_data = activeTab == 'sales-value' ? branch : salesman;
      if (code_data?.mt) {
        const findIndex = final_result.findIndex((r) => {
          const child_code = channelCode(r);
          return ['gt', 'mt'].includes(child_code) && child_code == 'mt';
        });
        if (findIndex > -1) {
          final_result[findIndex].status = code_data?.mt?.current_status || '';
          final_result[findIndex].created_by =
            code_data?.mt?.created_by?.name || '';
          final_result[findIndex].last_updated =
            code_data?.mt?.updated_by?.name || '';
        }
      } else {
        final_result = final_result.map((r) => {
          const child_code = channelCode(r);
          if (['gt', 'mt'].includes(child_code) && child_code == 'mt') {
            r = resetValue(r);
          }
          return r;
        });
      }
      if (code_data?.gt) {
        const findIndex = final_result.findIndex((r) => {
          const child_code = channelCode(r);
          return ['gt', 'mt'].includes(child_code) && child_code == 'gt';
        });
        if (findIndex > -1) {
          final_result[findIndex].status = code_data?.gt?.current_status || '';
          final_result[findIndex].created_by =
            code_data?.gt?.created_by?.name || '';
          final_result[findIndex].last_updated =
            code_data?.gt?.updated_by?.name || '';
        }
      } else {
        final_result = final_result.map((r) => {
          const child_code = channelCode(r);
          if (['gt', 'mt'].includes(child_code) && child_code == 'gt') {
            r = resetValue(r);
          }
          return r;
        });
      }
    }

    // Check Channel Value
    if (activeTab == 'sales-value') {
      if (channel && Object.keys(channel).length) {
        const findIndex = final_result.findIndex((r) => {
          return r?.target_type == 'channel';
        });
        if (findIndex > -1) {
          final_result[findIndex].status = channel?.current_status || '';
          final_result[findIndex].created_by = channel?.created_by?.name || '';
          final_result[findIndex].last_updated =
            channel?.updated_by?.name || '';
        }
      } else {
        final_result = final_result.map((r) => {
          if (r.target_type == 'channel') {
            r = resetValue(r);
          }
          return r;
        });
      }
    }

    // Check National Value
    if (['sales-value', 'doors'].includes(activeTab)) {
      if (national && Object.keys(national).length) {
        const findIndex = final_result.findIndex((r) => {
          return r?.target_type == 'national';
        });
        if (findIndex > -1) {
          final_result[findIndex].status = national?.current_status || '';
          final_result[findIndex].created_by = national?.created_by?.name || '';
          final_result[findIndex].last_updated =
            national?.updated_by?.name || '';
        }
      } else {
        final_result = final_result.map((r) => {
          if (r.target_type == 'national') {
            r = resetValue(r);
          }
          return r;
        });
      }
    }

    final_result = final_result.map((r) => {
      if (r.status == '-') {
        r.status = '';
      }
      return r;
    });

    return final_result;
  };

  const doSearch = async () => {
    setLoading(true);
    try {
      const default_params = {
        params: {
          filter: {
            target_type: activeTab,
            year: filterYear,
          },
        },
      };
      const response = await getTargetSetting.request(default_params);
      const data = response?.data?.data;
      const result = handleTargetSettingValues({
        national: data?.national || {},
        channel: data?.channel || {},
        branch: data?.branch || {},
        salesman: data?.salesman || {},
      });

      setTableData(result);
      setLoading(false);
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  const onAction = async (data, type) => {
    if (type == 'hapus') {
      dispatch(
        showAlert({
          show: true,
          title: 'Remove',
          description: 'This document will be deleted. Do you want to proceed?',
          onCallback: async () => {
            try {
              const params = {
                params: {
                  filter: {
                    year: filterYear,
                  },
                },
              };
              if (['sales-value', 'product-focus'].includes(activeTab)) {
                if (data?.target_type?.indexOf('gt') > -1) {
                  params.params.filter['type'] = 'gt';
                } else if (data?.target_type?.indexOf('mt') > -1) {
                  params.params.filter['type'] = 'mt';
                }
              }
              if (
                data?.target_id &&
                !IGNORE_TARGET_ID.includes(data?.target_id)
              ) {
                params.params.filter['team_id'] = data?.target_id;
              }
              const targetType = data?.target_type
                ?.replace('-mt', '')
                ?.replace('-gt', '');
              await MsB2b.deleteTargetSetting(activeTab, targetType, params);
              doSearch();
            } catch (error) {}
          },
        }),
      );
    } else {
      props.navigation.navigate('TargetSettingUploadScreen', {
        type: activeTab,
        targetType: data?.target_type,
        targetId: data?.target_id,
        targetName: data?.target_name,
        targetYear: filterYear,
        title: data?.title,
        titleSection: data?.title_section,
        action: type,
      });
    }
  };

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      doSearch();
    }
    props.navigation.addListener('focus', () => {
      if (!target_init) {
        doSearch();
      } else {
        target_init = false;
      }
    });
    return () => {
      mounted = false;
    };
  }, [activeTab, filterYear]);

  return (
    <Layout.Container>
      {isWeb && hasAccess ? (
        <>
          <Layout.Title title="Target Setting" />

          {/* Start Filter Section */}
          <View style={styles.tabContainer}>
            <View style={styles.tabWrapper}>
              {TABS.map((item, idx) => (
                <TouchableOpacity
                  style={[
                    styles.tabItem,
                    item.value == activeTab ? styles.tabItemActive : {},
                  ]}
                  activeOpacity={0.8}
                  onPress={() => setActiveTab(item.value)}
                  key={idx}>
                  <SociollaText
                    style={[
                      styles.tabItemText,
                      item.value == activeTab ? styles.tabItemTextActive : {},
                    ]}>
                    {item.label}
                  </SociollaText>
                </TouchableOpacity>
              ))}
            </View>
            <View style={styles.tabFilter}>
              <SociollaText style={styles.tabFilterText}>
                Sales Year
              </SociollaText>
              <View>
                <SelectBox
                  label="Year"
                  hideLabel
                  options={FILTER_YEARS}
                  value={filterYear}
                  placeholder="Select Year"
                  trackBy="value"
                  labelKey="label"
                  isDropdown={isWeb}
                  onChange={(value) => {
                    setFilterYear(value.value);
                  }}
                />
              </View>
            </View>
          </View>
          {/* End Filter Section */}

          <View style={styles.resultContainer}>
            <Table
              structures={TABLE_STRUCTURES}
              data={tableData}
              loading={loading}
              hasNoHide
              showFilter={false}
              showPagination={false}
              showSearch={false}
              hasCallback={true}
              onClickRow={({ data }) => onAction(data, 'view')}
              slot={{
                action: ({ data, index }) => {
                  const targetType = data?.target_type
                    ?.replace('-gt', '')
                    .replace('-mt', '');
                  const showButton =
                    hasAccessEditTargetSetting(activeTab, targetType) &&
                    data.status != 'need_approval';
                  return showButton ? (
                    <View style={styles.action} key={`action-${index}`}>
                      <TouchableOpacity
                        activeOpacity={0.8}
                        onPress={() => onAction(data, 'hapus')}>
                        <FontAwesome5 name="trash" size={15} color="black" />
                      </TouchableOpacity>
                    </View>
                  ) : (
                    <></>
                  );
                },
              }}
            />
          </View>
        </>
      ) : (
        <View style={styles.resultContainer}>
          <SociollaText>You have no permission</SociollaText>
        </View>
      )}
    </Layout.Container>
  );
};

const styles = StyleSheet.create({
  tabContainer: {
    width: '100%',
    padding: 15,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: Colors.white,
    borderRadius: 5,
    zIndex: 10,
  },
  tabWrapper: {
    flexDirection: 'row',
  },
  tabItem: {
    paddingVertical: 7,
    marginRight: 20,
    borderBottomColor: Colors.transparent,
    borderBottomWidth: 2,
  },
  tabItemActive: {
    borderBottomColor: Colors.blue0,
  },
  tabItemText: {
    fontSize: 13,
    color: Colors.grey1,
  },
  tabItemTextActive: {
    color: Colors.black0,
  },
  tabFilter: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  tabFilterText: {
    color: Colors.grey1,
    marginRight: 15,
  },
  resultContainer: {
    paddingVertical: 15,
  },
  action: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export default TargetSettingScreen;
